type Vendor = 'figma';

export class PrototypeUrl {
  private url: string;
  private vendor: Vendor;

  private errorMsg: string;

  constructor(url: string, vendor: Vendor) {
    this.url = url;
    this.vendor = vendor;
  }

  public isValid(): boolean {
    try {
      const url = this.toURL();
      return url ? this.isValidVendorUrl(url) : false;
    } catch (error: unknown) {
      if (error instanceof Error) {
        this.errorMsg = error.message;
      }

      return false;
    }
  }

  public toURL() {
    if (this.url === '') {
      return;
    }
    try {
      return new URL(this.url);
    } catch (error: unknown) {
      if (error instanceof Error) {
        error.message = 'Invalid URL. Expected: https://www.figma.com/proto/...';
      }
      throw error;
    }
  }

  public getErrorMessage() {
    return this.errorMsg;
  }

  private isValidVendorUrl(url: URL) {
    switch (this.vendor) {
      case 'figma':
        return this.isValidFigmaUrl(url);
      default:
        throw new Error('No vendor provided');
    }
  }

  private isValidFigmaUrl(url: URL) {
    const domain = url.hostname;
    const path = url.pathname;
    const params = url.searchParams;

    if (!domain.includes('figma')) {
      throw new Error('Invalid prototype URL. Expected: https://www.figma.com/proto/...');
    }

    if (!path.includes('/proto/')) {
      throw new Error('Invalid prototype URL. Expected: https://www.figma.com/proto/...');
    }

    if (!params.has('starting-point-node-id') && !params.has('node-id')) {
      throw new Error(
        "Invalid prototype URL. Ensure you copy the link by first launching the prototype and pressing the blue 'Share prototype' button."
      );
    }

    return true;
  }
}
